import React from 'react'
import EssHeader from '../sections/ESSHeader'
import AdminFooter from '../sections/AdminFooter'

function EssLayout({children}) {
    return (
        
        <div className="main" >
            <EssHeader />
                {children}
            <AdminFooter />
        </div>
    )
}

export default EssLayout